import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { GET_REQUIRE_TASKS_BEFORE_JOINING } from './require-tasks-before-joining.gql';
import { GetRequireTasksBeforeJoining } from './__generated__/GetRequireTasksBeforeJoining';

export function RequireTasksBeforeJoining() {
  const { setSnackbar } = useSnackbar();
  const apiUrl = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });
  const { data, refetch } = useCampfireQuery<GetRequireTasksBeforeJoining, undefined>(GET_REQUIRE_TASKS_BEFORE_JOINING);

  const enabled = data?.vm.configItem?.configItemValue?.flagValue ?? data?.vm.configItem?.defaultValue ?? false;

  const onChange = () => {
    campfireMutation
      .run({
        url: `${apiUrl}/vm/admin-console/config`,
        method: 'post',
        data: {
          value: !enabled,
          type: 'require-tasks-before-joining',
        },
      })
      .then(() => {
        setSnackbar({
          variant: 'success',
          open: true,
          message: 'Settings updated',
        });
        refetch();
      });
  };

  return (
    <Box display='flex' alignItems='center' mt={3}>
      <Switch
        checked={enabled}
        onChange={onChange}
        color='primary'
        inputProps={{ 'aria-label': 'require tasks before joining' }}
      />
      <Box ml={1}>
        <Typography style={{ fontWeight: 500, fontSize: '14px' }}>Require Tasks Before Joining</Typography>
        <Typography variant='body2' style={{ fontSize: '13px', color: '#808080' }}>
          Volunteers cannot join or apply for activities, or join waitlists, until all of their required tasks are
          approved. Admins can still add volunteers directly, and existing team members are not affected.
        </Typography>
      </Box>
    </Box>
  );
}
